
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suche",
      function () {
        return require("private-next-pages/suche/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suche"])
      });
    }
  